import { APP_CERTIFICATION_CREDENTIAL_ID } from '../constants/Certification';
export function getHasAppCertificationCredential(credentials) {
  return credentials.includes(APP_CERTIFICATION_CREDENTIAL_ID);
}